import { CubeTimeDimensionGranularity, Weekdays } from "../../../enum/cube-schema.enum";
import { IWorkingSessionsAnalyticsActivityScoresEnum } from "../../../enum/working-sessions-analytics-activity.enum";

export interface GetScoreTimeSeriesRequestParamsDto {
    startDate: string;
    endDate: string;
    frequency: CubeTimeDimensionGranularity | Weekdays;
    score: IWorkingSessionsAnalyticsActivityScoresEnum;
}